import { Injectable } from '@angular/core';
import { TripsItinerarySectionDirective } from '@features/trips/directives/trips-itinerary-section.directive';
import { BehaviorSubject, combineLatest, Observable } from 'rxjs';
import {
    distinctUntilChanged,
    map,
    shareReplay,
    switchMap,
} from 'rxjs/operators';

@Injectable({
    providedIn: 'any',
})
export class TripsItineraryMenuService {
    private _sections = new BehaviorSubject<TripsItinerarySectionDirective[]>(
        []
    );

    activeMenuItem: Observable<TripsItinerarySectionDirective>;
    activeIndex: Observable<number>;
    get sections(): Observable<TripsItinerarySectionDirective[]> {
        return this._sections;
    }

    constructor() {
        const visibilityChanges = this._sections.pipe(
            switchMap(sections =>
                combineLatest(sections.map(section => section.isVisible))
            )
        );
        this.activeIndex = visibilityChanges.pipe(
            map(visibility => visibility.indexOf(true) || 0),
            distinctUntilChanged(),
            shareReplay(1)
        );
        this.activeMenuItem = combineLatest([
            this._sections,
            this.activeIndex,
        ]).pipe(
            map(([sections, activeIndex]) => sections[activeIndex] || null),
            distinctUntilChanged(),
            shareReplay(1)
        );
    }

    updateMenuItems(sections: TripsItinerarySectionDirective[]) {
        this._sections.next(sections);
    }
}
